var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"copylink",class:[{'animated':_vm.animated}, _vm.classToSet],attrs:{"href":"#"},on:{"click":function($event){return _vm.copyText()},"animationend":function($event){_vm.animated = false}}},[_c('clipboard-icon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }